<template>
  <div>
    <CustomLoader v-if="isLoading" :width="70" />
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav v-if="showList && this.$route.path=='/ctt/subs-timeline-track'">
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2" :style="{ color: showList && this.$route.path=='/ctt/subs-timeline-track' ? color : 'black' }">
              {{ showList && this.$route.path=='/ctt/subs-timeline-track'?$route.name:'Shipment Tracking' }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false && showList && this.$route.path=='/ctt/subs-timeline-track'" :style="{ color: showList && this.$route.path=='/ctt/subs-timeline-track' ? color : 'black' }">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.booking_number ||
              Filter.container_number ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.search_txt ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.booking_number ||
                  Filter.container_number ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.search_txt ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getTimeLineList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getTimeLineList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="12"  v-if="showList && this.$route.path=='/ctt/subs-timeline-track'">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.pageSize"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="6"> </b-col>
        </b-row>
        <!-- <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2"> -->
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Booking NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Booking NO Filter"
                    id="booking_number" name="booking_number" autocomplete="off" v-model="Filter.booking_number"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Container No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container No Filter"
                    id="container_number" name="container_number" autocomplete="off" v-model="Filter.container_number"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line" @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name" @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="search_txt" name="search_txt" autocomplete="off" v-model="Filter.search_txt"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User" />
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            <!-- </b-collapse>
          </b-card>
        </div> -->
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="showList && this.$route.path=='/ctt/subs-timeline-track'?getTimeLineList:(!showList && (Filter.container_number ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.search_txt ||
              Filter.createdByFilter ||
              Filter.branchFilter))?getTimeLineList:[]" :fields="TimeLineFields"
                primary-key="id_email_section" :per-page="pagination.pageSize" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.pageSize
                    }}
                  </span>
                </template>
                <template slot="JobNo" slot-scope="row">
                  <ShipmentTimeline :eventDet="row.item" />
                </template>

              </b-table>
            </div>
            <div v-if="showList && this.$route.path=='/ctt/subs-timeline-track'">
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.pageSize"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import TrasportService from "../../services/TrasportService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";

import ShipmentTimeline from "./ShipmentTimeline.vue"


export default {
  name: "timelineTrackDash",
  props: {
    showList: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),

      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),

    ];
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    Promise.all(storePromises)
      .then(() => delay(1000))
      .then(() => {
        console.log("All store actions completed.");
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getTimeLineList: [],
      totalData: 0,

      TimeLineFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Time Line",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        // {
        //   key: "ClientName",
        //   mainkey: "ClientName",
        //   label: "Client/Sline",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "EmptyPickup",
        //   mainkey: "EmptyPickup",
        //   label: "Empty Pickup",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "OriginLoc",
        //   mainkey: "OriginLoc",
        //   label: "Origin",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "PolLoc",
        //   mainkey: "PolLoc",
        //   label: "POL",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },

        // {
        //   key: "Tsp1Loc",
        //   mainkey: "Tsp1Loc",
        //   label: "TSP1",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "Tsp2Loc",
        //   mainkey: "Tsp2Loc",
        //   label: "TSP2",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "PodLoc",
        //   mainkey: "PodLoc",
        //   label: "POD",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "DlvLoc",
        //   mainkey: "DlvLoc",
        //   label: "DLV",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "EmptyReturnLoc",
        //   mainkey: "EmptyReturnLoc",
        //   label: "Empty Return",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "Vessel1",
        //   mainkey: "Vessel1",
        //   label: "Vessel",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },

        // {
        //   key: "Vessel1",
        //   mainkey: "Vessel1",
        //   label: "Vessel",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },

        // {
        //   key: "SobPlanInitial",
        //   mainkey: "SobPlanInitial",
        //   label: "SOB",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
      ],

      pagination: {
        currentPage: 1,
        pageSize: 50,
        totalPages: 0,
        totalCounts: 0,
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        booking_number: "",
        container_number: "",
        clientFilter: "",
        slineFilter: "",
        search_txt: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    ShipmentTimeline,
  },
  computed: {},
  watch: {},
  methods: {

    clearFilter() {
      this.Filter = {
        booking_number: "",
        container_number: "",
        clientFilter: "",
        slineFilter: "",
        search_txt: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getTimeLineTrackDash(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.totalData = 0;
      this.getTimeLineList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getTimeLineList",
        type: type,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        isAll: this.generateExcel,
        search_txt: this.Filter.search_txt,
      };

      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};

      TrasportService.getTimeLineSubscriptionTrack(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;

          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "TrackReport.xlsx");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.pagination = data.pagination;
                this.totalData = data.pagination.totalCounts;
                this.getTimeLineList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getTimeLineList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getTimeLineTrackDash("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.pageSize - this.pagination.pageSize;
      }
      this.getTimeLineTrackDash("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.pageSize - this.pagination.pageSize;
      }
      this.getTimeLineTrackDash("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// timelineTrackDash.vue?0f4636fa